import { ActionType } from '../../types';

export const RegistrationActions = {
    loadEulaStarted: (language: string) =>
        ({
            type: 'Registration/LoadEula/Started',
            payload: { language },
        } as const),

    loadEulaSucceeded: (content: string) =>
        ({
            type: 'Registration/LoadEula/Succeeded',
            payload: { content },
        } as const),

    loadEulaFailed: () =>
        ({
            type: 'Registration/LoadEula/Failed',
        } as const),

    validateUserRegistrationStarted: () =>
        ({
            type: 'Registration/ValidateUser/Started',
        } as const),

    validateUserRegistrationSucceeded: (fname?: string | null, lname?: string | null, phone?: string | null) =>
        ({
            type: 'Registration/ValidateUser/Succeeded',
            payload: { fname, lname, phone },
        } as const),

    validateUserRegistrationFailed: (errorCode: string) =>
        ({
            type: 'Registration/ValidateUser/Failed',
            payload: { errorCode },
        } as const),

    registerUserStarted: () =>
        ({
            type: 'Registration/RegisterUser/Started',
        } as const),

    registerUserSucceeded: (email: string, organizationName: string | null) =>
        ({
            type: 'Registration/RegisterUser/Succeeded',
            payload: { email, organizationName },
        } as const),

    registerUserFailed: (errorCode: string) =>
        ({
            type: 'Registration/RegisterUser/Failed',
            payload: { errorCode },
        } as const),
    inviteUserStarted: () =>
        ({
            type: 'Registration/InviteUser/Started',
        } as const),

    inviteUserSucceeded: () =>
        ({
            type: 'Registration/InviteUser/Succeeded',
        } as const),

    inviteUserFailed: (errorCode: string) =>
        ({
            type: 'Registration/InviteUser/Failed',
            payload: { errorCode },
        } as const),
    inviteUserUnmounted: () =>
        ({
            type: 'Registration/InviteUser/Unmounted',
        } as const),
    deleteUserStarted: () =>
        ({
            type: 'Registration/deleteUser/Started',
        } as const),

    deleteUserSucceeded: () =>
        ({
            type: 'Registration/deleteUser/Succeeded',
        } as const),

    delteUserFailed: (errorCode: string) =>
        ({
            type: 'Registration/deleteUser/Failed',
            payload: { errorCode },
        } as const),
    deleteUserUnmounted: () =>
        ({
            type: 'Registration/deleteUser/Unmounted',
        } as const),
};

export type RegistrationActions = ActionType<typeof RegistrationActions>;
